import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AccordionZone.styles';

import AccordionMenu from '../accordionmenu/AccordionMenu';
import AccordionLocation from '../accordionlocation/AccordionLocation';
import Icon from '../../common/icon/Icon';

class AccordionZone extends Component {
  state = {
    isOpen: false
  };
  options = [
    {
      text: I18n.t('edit.edit'),
      value: 'edit'
    },
    {
      text: I18n.t('delete.delete'),
      value: 'delete'
    }
  ];
  toggleOpen = () => {
    let isOpen = !this.state.isOpen;
    if (isOpen) {
      this.props.onOpenZone(this.props.zone.id);
    }
    this.setState({ isOpen });
  };
  renderLocation = (location, index) => {
    return (
      <AccordionLocation
        key={index}
        location={location}
        delete={this.props.onDeleteLocation}
        onEdit={this.props.onEditLocation}
      />
    );
  };
  handleZoneActions = action => {
    if (action === 'delete') {
      this.props.delete(this.props.zone);
    }
    if(action ==='edit'){
      this.props.edit(this.props.zone);
    }
  };
  render() {
    let iconStyles = [
      styles.icon
      // ...(!this.props.zone.locationCount ? [styles.iconHidden] : [])
    ];
    return (
      <Fragment>
        <div className={css(styles.zone, this.props.styles)}>
          <Icon
            value={this.state.isOpen ? 'chevron-up' : 'chevron-down'}
            styles={iconStyles}
            onClick={this.toggleOpen}
          />
          <div className={css(styles.field)}>
            <span className={css(styles.name)}>{this.props.zone.name}</span>
            {this.state.isOpen && (
              <span className={css(styles.address)}>
                {I18n.t('models.location.address')}
              </span>
            )}
          </div>
          <AccordionMenu
            styles={styles.options}
            options={this.options}
            handleClick={this.handleZoneActions}
          />
        </div>
        {this.state.isOpen &&
          this.props.zone.id in this.props.locations &&
          !this.props.locations[this.props.zone.id].length && (
            <AccordionLocation location={{ name: I18n.t('data.noData') }} />
          )}
        {this.state.isOpen &&
          this.props.zone.id in this.props.locations &&
          this.props.locations[this.props.zone.id].map(this.renderLocation)}
      </Fragment>
    );
  }
}

export default AccordionZone;



// WEBPACK FOOTER //
// ./src/components/data/accordionzone/AccordionZone.js